import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import { createSearchParamsEditHintSteps } from 'entities/kyrgyzstan/lib'

import { useGuideTooltip } from 'shared/hooks/use-guide-tooltip'
import { JoyrideTour } from 'shared/ui/joyride-tour'

const COOKIE_KEY = 'kyrgyzstan_search_params_edit_hint'

export const SearchParamsEditHintTour = () => {
  const { t } = useTranslation()
  const content = t('kyrgyzstan_block.search_result.edit_header_hint')
  const steps = useMemo(
    () => createSearchParamsEditHintSteps(content),
    [content],
  )

  const { run, locale, handleCallback } = useGuideTooltip({
    steps,
    cookieKey: COOKIE_KEY,
    localeKeys: {
      last: 'kyrgyzstan_block.search_result.edit_header_hint_ok',
    },
  })

  return (
    <JoyrideTour
      steps={steps}
      run={run}
      onCallback={handleCallback}
      locale={locale}
    />
  )
}
